import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} fill="none" ref={ref} {...props}>
    <g>
      <path
        fill="#fff"
        d="M1.191 5.454c.15.406.561.637.993.63L2.4 6.08c3.59-.057 7.226-.002 10.947.013l.616.003c.438 0 .847-.245.997-.656.16-.443.262-.899.262-1.367 0-.491-.1-.973-.276-1.435-.142-.376-.514-.602-.915-.62a124.388 124.388 0 0 0-11.923 0c-.39.018-.754.233-.896.598a4.02 4.02 0 0 0-.275 1.457c0 .474.09.934.255 1.381Z"
      />
      <path
        fill="#fff"
        d="M2.13 13.814c.085.505.512.876 1.022.92 1.51.133 3.092.31 4.72.31 1.644 0 3.227-.111 4.757-.28.493-.055.892-.429.972-.919.189-1.157.315-2.356.315-3.596 0-1.244-.114-2.46-.31-3.616a1.076 1.076 0 0 0-.26-.54c-3.721-.015-7.357-.07-10.947-.013-.134.146-.227.33-.263.536a21.266 21.266 0 0 0-.308 3.633c0 1.23.11 2.417.302 3.565Z"
      />
      <path
        stroke="#383838"
        d="M2.399 6.08c-.072 0-.143.002-.215.003-.432.008-.844-.223-.993-.629a3.987 3.987 0 0 1-.255-1.381c0-.499.094-.989.275-1.457.142-.365.505-.58.896-.6a124.388 124.388 0 0 1 11.923.001c.401.019.773.245.915.621.176.462.276.944.276 1.435 0 .468-.101.924-.262 1.367-.15.411-.56.657-.997.656l-.616-.003M2.399 6.08c-.134.146-.227.33-.263.536a21.266 21.266 0 0 0-.308 3.633c0 1.23.11 2.417.302 3.565.085.505.512.876 1.022.92 1.51.133 3.092.31 4.72.31 1.644 0 3.227-.111 4.757-.28.493-.055.892-.429.972-.919.189-1.157.315-2.356.315-3.596 0-1.244-.114-2.46-.31-3.616a1.076 1.076 0 0 0-.26-.54M2.399 6.08c3.59-.057 7.226-.002 10.947.013"
      />
      <path stroke="#383838" strokeLinecap="round" strokeLinejoin="round" d="M6.225 9.43H9.52" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconReserveBox = memo(ForwardRef);
export default IconReserveBox;
